import React, { useEffect, useState } from 'react';
import {
    FlexDiv,
    Heading2,
    TextDefault,
    TextTiny,
    palette,
} from '@awarego-ui/components';
import { CircularProgress } from '@mui/material';

const SCAN_STEPS = [
    'Searching LinkedIn public profile…',
    'Reading company website and press releases…',
    'Searching conference and event listings…',
    'Checking GitHub and open-source activity…',
    'Looking at Crunchbase and trade press…',
    'Compiling threat profile…',
    'Generating personalised analysis…',
];

export const ATTACK_STEPS = [
    'Selecting plausible attack vectors…',
    'Matching attack patterns to your signals…',
    'Drafting CEO/vendor impersonation example…',
    'Drafting recruiter/HR lure example…',
    'Drafting conference / supplier follow-up example…',
    'Adding "why this works" explanations…',
    'Finalising your personalised phishing scenarios…',
];

export default function AwareExposeScanner({
    title,
    subtitle,
    steps,
    intervalMs = 1800,
}) {
    const resolvedSteps =
        Array.isArray(steps) && steps.length > 0 ? steps : SCAN_STEPS;
    const resolvedTitle = title || 'Building your threat profile';
    const resolvedSubtitle =
        subtitle ||
        'Collecting publicly available intelligence and preparing personalised attacks…';
    const [step, setStep] = useState(0);
    useEffect(() => {
        setStep(0);
        const t = setInterval(() => {
            setStep((s) => Math.min(s + 1, resolvedSteps.length - 1));
        }, intervalMs);
        return () => clearInterval(t);
    }, [resolvedSteps, intervalMs]);
    return (
        <FlexDiv
            column
            alignCenter
            gap={16}
            style={{
                width: '100%',
                textAlign: 'center',
            }}
        >
            <CircularProgress
                size={56}
                thickness={4}
                sx={{ color: palette.evergreen.aspargus }}
            />
            <Heading2 displayBlock center>
                {resolvedTitle}
            </Heading2>
            <TextDefault color={palette.graphite.charcoal} center>
                {resolvedSubtitle}
            </TextDefault>
            <FlexDiv column gap={6} mt={16} style={{ width: '100%' }}>
                {resolvedSteps.map((s, i) => {
                    const color =
                        i < step
                            ? palette.evergreen.aspargus
                            : i === step
                              ? palette.graphite.heavyMetal
                              : palette.graphite.ash;
                    return (
                        <FlexDiv key={i} alignCenter gap={8} py={4}>
                            <span
                                style={{
                                    width: 16,
                                    textAlign: 'center',
                                    color,
                                    fontWeight: i === step ? 700 : 400,
                                }}
                            >
                                {i < step ? '✓' : i === step ? '›' : '·'}
                            </span>
                            <TextTiny
                                color={color}
                                bold={i === step}
                                style={{ display: 'block' }}
                            >
                                {s}
                            </TextTiny>
                        </FlexDiv>
                    );
                })}
            </FlexDiv>
        </FlexDiv>
    );
}
